import React from "react";
import {
  Checkbox,
  Link as MUILink,
  useTheme,
  type CheckboxProps,
} from "@mui/material";

type TermsAndConditionsProps = {
  isChecked?: boolean;
  handleTermsAndCondition?: CheckboxProps["onChange"];
};

const TermsAndConditions = ({
  isChecked,
  handleTermsAndCondition,
}: TermsAndConditionsProps) => {
  const theme = useTheme();
  return (
    <div className="row mt-3">
      <div className="col-12 d-flex justify-content-end">
        <MUILink
          variant="body2"
          target="_blank"
          rel="noopener noreferrer"
          href="https://hyperlocology.com/user-terms-and-conditions"
          className="mr-1 p-1 text-underline"
          sx={{
            color: theme.palette.primary.main, // theme primary color
            textDecoration: "underline",
            "&:hover": {
              color: theme.palette.primary.main, // keep same on hover
              textDecoration: "underline",
            },
          }}
        >
          Accept terms and conditions
        </MUILink>
        <Checkbox
          edge="start"
          color="primary"
          name="termsAndConditions"
          className="py-0 ml-1"
          checked={isChecked}
          onChange={handleTermsAndCondition}
        />
      </div>
    </div>
  );
};

export default TermsAndConditions;
